// extracted by mini-css-extract-plugin
export default {"modal":"H8-z","overlay":"I8-z","outfitSelector":"J8-z","outfitHeading":"K8-z","itemContainer":"L8-z","item":"M8-z","selected":"N8-z"};